import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'DDNSS',
      href: '/en/Internet_Access/DDNS_Provider/DDNSS/',
    },
    {
      text: 'NoIP',
      href: '/en/Internet_Access/DDNS_Provider/NoIP/',
    },
    {
      text: 'Selfhost',
      href: '/en/Internet_Access/DDNS_Provider/Selfhost/',
    },
    {
      text: '◄ DDNS Provider',
      href: '/en/Internet_Access/DDNS_Provider/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={6}
        aria-label="Use a Third Party DDNS services with your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}